<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <b-row>
            <b-col>
              <b-form-group label="Sipariş Numarası" label-for="item-name">
                <b-form-input ref="barkodKargo" class="inputx" placeholder="Sipariş Numarası..." v-model="sipNo" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Tesellüm Numarası" label-for="item-name">
                <b-form-input class="inputx" placeholder="Tesellüm Numarası..." v-model="tesellumNo" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Teslim Alan" label-for="item-name">
                <b-form-input ref="barkodKargo" class="inputx" placeholder="Teslim Alan..." v-model="teslimAlan" />
              </b-form-group>
            </b-col>
            <b-col align-self="end">
              <vs-button type="gradient" color="danger" id="loading-tesellum-gonder" class="vs-con-loading__container"
                icon="send" radius @click="kargoTesellumAktar()"></vs-button>
            </b-col>
          </b-row>
        </vs-card>
        <vs-card>
          <b-row align-v="center">
            <b-col>
              <b-form-group label="Pazaryeri" label-for="item-name">
                <v-select v-model="selectedMarketplace" :options="pazaryerOptions" label="name" style=""></v-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Arama" label-for="item-name">
                <b-form-input ref="barkodKargo" class="inputx" placeholder="Arama..." @keyup.enter="kargoTesellumList()"
                  v-model="aranan" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Barkod" label-for="item-name">
                <b-form-input ref="barkodKargo" class="inputx" placeholder="Barkod..." v-model="aranan1"
                  @input="kargoTesellumList()" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Tarih" label-for="item-name">
                <b-form-datepicker id="datepicker" v-model="tarihDegeri" size="md" local="en" class="mb-2"
                  today-variant="danger" placeholder="-"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />
              </b-form-group>
            </b-col>
            <b-col>
              <vs-button style="border-radius: 5px" type="gradient" color="success" id="button-with-loading-yeni"
                class="vs-con-loading__container" @click="kargoTesellumList()">Ara</vs-button>
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-card style="height: 400px">
          <b-row>
            <b-col>
              <vs-button style="border-radius: 5px" type="gradient" color="success"
                @click="tesellumListYazdir()">Yazdır</vs-button>
            </b-col>
            <b-col cols="12">
              <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
                :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="kargoTesellumListesi"
                :localeText="localeText" @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered"
                :rowSelection="rowSelection">
              </ag-grid-vue>
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <kargoTesellumYazdir ref="tesellumYazdir" />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import kargoTesellumButon from "../components/uzum-components/pazaryeri-components/kargoTesellumButon.vue";
import kargoTesellumYazdir from "../components/uzum-components/pazaryeri-components/kargoTesellumYazdir.vue";
export default {
  data() {
    return {
      teslimAlan: "",
      sipNo: "",
      tesellumNo: "",
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      kargoTesellumListesi: [],
      tarihDegeri: "",
      pazaryerOptions: [],
      selectedMarketplace: "",
      aranan: "",
      aranan1: "",
      barkodKargo: "",
      localeText: null,
      rowSelection: null,
    };
  },
  methods: {
    tesellumListYazdir() {
      this.$refs.tesellumYazdir.yazdir();
    },
    kargoTesellumAktar() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      vs.loading({
        background: "#6e048a",
        color: "#fff",
        container: "#loading-tesellum-gonder",
        scale: 0.45,
      });

      const args = {
        token: Store.state.tokenId,
        cargonumber: vm.sipNo,
        receiptno: vm.tesellumNo,
        deliveryarea: vm.teslimAlan,
      };
      soap.createClient(url, function (err, client) {
        client.cargoTracking(args, function (err, result) {
          if (result.cargoTrackingResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            try {
              vm.veriler = JSON.parse(result.cargoTrackingResult);
              console.log(vm.veriler);
              console.log(vm.kargoTesellumListesi);
              if (vm.veriler[0].Sonuc == "İşlem Daha Önce Yapılmış") {
                vs.loading.close("#loading-tesellum-gonder > .con-vs-loading");
                vs.notify({
                  title: "Tesellüm Gönderim",
                  text: "İşlem Daha Önce Yapılmış",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
              } else {
                vs.loading.close("#loading-tesellum-gonder > .con-vs-loading");
                vs.notify({
                  title: "Tesellüm Gönderim",
                  text: "Tesellüm Gönderimi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                vm.teslimAlan = "";
                vm.sipNo = "";
                vm.tesellumNo = "";
              }
            } catch (error) {
              vs.loading.close("#loading-tesellum-gonder > .con-vs-loading");
              vs.notify({
                title: "Tesellüm Gönderim",
                text: "Tesellüm Gönderiminde Hata Var",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    kargoTesellumList() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        tarih: vm.tarihDegeri,
        program: vm.selectedMarketplace.name,
        aranan: vm.aranan,
        aranan1: vm.aranan1,
      };
      soap.createClient(url, function (err, client) {
        client.cargoTrackingList(args, function (err, result) {
          if (result.cargoTrackingListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.cargoTrackingListResult);
            vm.kargoTesellumListesi = vm.veriler;
            console.log(vm.veriler);
            console.log(vm.kargoTesellumListesi);
            vm.$refs.tesellumYazdir.tesellumListGet(vm.kargoTesellumListesi);
          }
        });
      });
    },
  },
  components: {
    kargoTesellumButon,
    kargoTesellumYazdir,
    AgGridVue,
    "v-select": vSelect,
  },
  created() {
    this.pazaryerOptions = Store.state.uzum.menuListForTabs;
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },
  mounted() {
    console.log(this.$refs);
    this.$refs.barkodKargo.$el.focus();
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Fatura No",
        field: "receiptno",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Pazaryeri",
        field: "program",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Teslimat İli",
        field: "shipCity",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Teslimat İlçesi",
        field: "shipDistrict",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Teslimat Adresi",
        field: "shipFullAddress",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Teslimat Adı",
        field: "shipFullName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Adı",
        field: "cargoProviderName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Takip Numarası",
        field: "cargoTrackingNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Teslimat Yeri",
        field: "deliveryarea",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>
